var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tbody",
    [
      _vm._l(_vm.items, function (item, index) {
        return _vm.includeDraft(item) &&
          (!_vm.showActive || _vm.hideOptions(item))
          ? [
              _c(
                "tr",
                {
                  key: item.id,
                  class: [
                    "workPermit__item",
                    "workPermit__item-" + (index % 2 ? "odd" : "even"),
                  ],
                },
                [
                  _c("td", [
                    _c("i", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showCollapse(item),
                          expression: "showCollapse(item)",
                        },
                      ],
                      class: [
                        "tree-arrow pointer",
                        item.collapsed ? "fa-angle-right" : "fa-angle-down",
                        "fa angle",
                      ],
                      on: {
                        click: function ($event) {
                          return _vm.switchArrow(item)
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "bold" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.workPermitTypeLabel(item.type)) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c(
                      "span",
                      {
                        class: { link_text: _vm.includeDraft(item) },
                        on: {
                          click: function ($event) {
                            _vm.includeDraft(item) && _vm.viewWorkPermit(item)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(item.code || _vm.emptyValue) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(item.workType || _vm.emptyValue))]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        _vm._f("customStatusLabel")(
                          _vm.formatStatus(item.status)
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(_vm._s(_vm.getBuilding(item) || _vm.emptyValue)),
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.getFloors(item)))]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      _vm._s((item.contractor || {}).name || _vm.emptyValue)
                    ),
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.getDuration(item)))]),
                ]
              ),
              _vm._v(" "),
              _vm._l(item.hoistings, function (hoisting) {
                return !_vm.excludeDraftHoisting(hoisting)
                  ? _c(
                      "tr",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !item.collapsed,
                            expression: "!item.collapsed",
                          },
                        ],
                        key: hoisting.id,
                        class: [
                          "workPermit__item",
                          "workPermit__item-" + (index % 2 ? "odd" : "even"),
                        ],
                      },
                      [
                        _c("td"),
                        _vm._v(" "),
                        _c("td", [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.workPermitTypeLabel(hoisting.type))
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.hotWorkRequired(hoisting)
                            ? _c("img", {
                                attrs: {
                                  src: "ic_hotwork.png",
                                  alt: "hotwork",
                                },
                              })
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "span",
                            {
                              class: { link_text: _vm.includeDraft(item) },
                              on: {
                                click: function ($event) {
                                  _vm.includeDraft(item) &&
                                    _vm.viewWorkPermit(item, hoisting.id)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(hoisting.code || _vm.emptyValue) +
                                  "\n        "
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(hoisting.description || _vm.emptyValue)
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm._f("customStatusLabel")(
                                _vm.formatStatus(hoisting.status)
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(_vm.getBuilding(hoisting) || _vm.emptyValue)
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(_vm.getFloors(hoisting)))]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              (hoisting.contractor || {}).name || _vm.emptyValue
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(_vm.getDuration(hoisting)))]),
                      ]
                    )
                  : _vm._e()
              }),
            ]
          : _vm._e()
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }